(() => {
  class DecoRatonCartRecommendations extends HTMLElement {
    connectedCallback() {
      this.selectRecommendations();
      this.addEventListener('click', (event) => this.handleClick(event));
    }

    selectRecommendations() {
      const gap = Number(this.dataset.gap || 0);
      const target = gap > 0 ? gap : 4000;
      const items = Array.from(this.querySelectorAll('[data-rec]'));

      items
        .sort((a, b) => {
          const aPrice = Number(a.dataset.price || 0);
          const bPrice = Number(b.dataset.price || 0);
          const aScore = Math.abs(aPrice - target);
          const bScore = Math.abs(bPrice - target);
          if (aScore !== bScore) return aScore - bScore;
          return aPrice - bPrice;
        })
        .slice(0, 3)
        .forEach((item) => item.classList.add('is-selected'));
    }

    async handleClick(event) {
      const button = event.target.closest('[data-dr-cart-add]');
      if (!button || button.classList.contains('is-loading')) return;

      const variantId = button.dataset.variantId;
      const cartDrawer = document.querySelector('cart-drawer');
      if (!variantId || !cartDrawer) return;

      button.classList.add('is-loading');
      button.disabled = true;

      try {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        const response = await fetch(routes.cart_add_url, config);
        const data = await response.json();

        if (data.status) throw new Error(data.description || data.message || 'Nie udało się dodać produktu.');

        cartDrawer.setActiveElement(button);
        cartDrawer.renderContents(data);
      } catch (error) {
        console.error(error);
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    }
  }

  if (!customElements.get('decoraton-cart-recommendations')) {
    customElements.define('decoraton-cart-recommendations', DecoRatonCartRecommendations);
  }
})();